import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios';
import { Form, Button, Spinner, Alert, Image } from 'react-bootstrap';
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode';
import { Modal } from 'react-bootstrap';

const BlingIntegrationRequest = () => {
    const [apiKey, setApiKey] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [code, setCode] = useState('');
    const [state, setState] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const codeParam = params.get('code');
        const stateParam = params.get('state');

        setCode(codeParam);
        setState(stateParam);
    }, []);



    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        window.open('https://www.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=10e7aa17bb8eef3bef84ebafb3318b3fc2946714&state=617caaef60c7bad3af5376cbe352cdc7')

    };

    const handleAuth = async (e) => {
        e.preventDefault();

        try {
            const response = await apinode.get(`/bling/auth/${localStorage.idconta}`, {
                params: {
                    code: code,
                    state: state,
                },
            });

            if (response.data) {
                setSuccess('Integração solicitada com sucesso!');
                console.log(response.data);
            } else {
                setError('Falha ao solicitar integração.');
                //  handleOpen();
            }
        } catch (err) {
            setError('Erro ao conectar com o servidor.');
            // handleOpen();
        } finally {
            setLoading(false);
        }

    };

    return (
        <>
            <Navbar />
            <div className="mt-page">
                <h1>
                    Solicitar Integração com
                    <Image src="/Images/bling.png" rounded width="100" height="75" className="me-2" />
                </h1>
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>Code:</Form.Label>
                        <Form.Control type="text" value={code} readOnly />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>State:</Form.Label>
                        <Form.Control type="text" value={state} readOnly />
                    </Form.Group>
                    <Button variant="primary" className='mt-2' type="submit" disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Solicitar Integração'}
                    </Button>

                    <Button variant="success" className='mt-2' onClick={handleAuth} disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Autenticar'}
                    </Button>
                </Form>
                {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                {success && <Alert variant="success" className="mt-3">{success}</Alert>}
            </div>



            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg"
                dialogClassName="custom-modalzpl">
                <Modal.Header closeButton>
                    <Modal.Title>Autorização Bling</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        title="Conteúdo da Resposta"
                        srcDoc={modalContent}
                        style={{ width: '100%', height: '400px', border: 'none' }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default BlingIntegrationRequest;
